import React from "react";
import styled from "styled-components";
import CircularProgress from "@material-ui/core/CircularProgress";
import { colors } from "../layout/constants";

const LoadingView = ({ message }) => {
	return (
		<LoadingStyled>
			<h2>{message}</h2>
			<CircularProgress />
		</LoadingStyled>
	);
};

const LoadingStyled = styled.section`
	align-items: center;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	justify-content: center;
	margin-top: 20px;
	h2 {
		margin-top: 0;
	}
	.MuiCircularProgress-svg circle {
		stroke-width: 2;
		color: ${colors.primary};
	}
`;

export default LoadingView;
